import { getDb } from '../adapter'
import { TABLE_NAME } from '../constants/tables'


/* 

export const addMessages = async (messages) => {
    const db = await openDB()
    return new Promise(async (resolve, reject) => {
        if (isWeb()) {
            return resolve()
        } else {
            try {
                let index = 0
                while (index < messages.length) {
                    const statement = db.prepareSync(`
                        INSERT INTO ${DOTI_MESSAGES} 
                        (role, content, timestamp, type, 'values')
                        VALUES (
                            ?,?,?,?,?
                        );
                    `)
                    let message = messages[index]
                    statement.executeSync([
                        message.role || '',
                        message.content || '',
                        message.timestamp,
                        message.type || '',
                        JSON.stringify(message.values || []),
                    ])
                    index++
                }

                console.log('Se guardaron los mensajes')
                resolve()
            } catch (error) {
                console.error('Error in AddMessages:', error)
                reject(error)
            }
        }
    })
}

export const getMessages = async () => {
    const db = await openDB()
    return new Promise(async (resolve, reject) => {
        if (isWeb()) {
            return resolve([])
        } else {
            try {
                const statement = db.prepareSync(`
                    SELECT 
                        _id,
                        role,
                        content,
                        timestamp,
                        type,
                        values
                    FROM ${DOTI_MESSAGES}
                    ORDER BY _id ASC;
                `)

                const rows = statement.executeSync()

                const parsed = rows.map((row) => ({
                    _id: row._id,
                    role: row.role,
                    content: row.content,
                    timestamp: row.timestamp,
                    type: row.type,
                    values: row.values ? JSON.parse(row.values) : [],
                }))

                resolve(parsed)
            } catch (error) {
                console.error('Error in getMessages:', error)
                reject(error)
            }
        }
    })
}

*/
export const addMessages = async (messages) => {
    try {
        const db = await getDb()

        const query = `INSERT INTO ${TABLE_NAME.DOTI_MESSAGES} 
(role, content, timestamp, type, "values")
VALUES (?, ?, ?, ?, ?);
`
        for (const message of messages) {
            const params = [
                message.role || '',
                message.content || '',
                message.timestamp,
                message.type || '',
                JSON.stringify(message.values || []),
            ]

            await db.run({ sql: query, params: params })
        }
    } catch (error) {
        console.error('Error adding messages to the database:', error)
    }
}

export const clearMessages = async () => {
    try {
        const db = await getDb()
        await db.run({ sql: `DELETE FROM ${TABLE_NAME.DOTI_MESSAGES};`, params: [] })
    } catch (error) {
        console.error('Error clearing doti messages:', error)
    }
}

export const getMessages = async () => {
    try {
        const query = `SELECT
                            _id,
                            role,
                            content,
                            timestamp,
                            type,
                            "values"
                        FROM ${TABLE_NAME.DOTI_MESSAGES}
                        ORDER BY _id ASC;`
        const db = await getDb()
        const result = await db.getAll({ sql: query })

        console.log('Retrieved messages from the database:', result.length)
        const parsed = result.map((row) => ({
            _id: row._id,
            role: row.role,
            content: row.content,
            timestamp: row.timestamp,
            type: row.type,
            values: row.values ? JSON.parse(row.values) : [],
        }))

        return parsed
    } catch (error) {
        console.error('Error retrieving messages from the database:', error)
        return []
    }
}

export const saveSuggestedQuestions = async (questions: string[]) => {
    try {
        const db = await getDb()
        await db.run({ sql: `DELETE FROM ${TABLE_NAME.DOTI_SUGGESTED_QUESTIONS};`, params: [] })
        const query = `INSERT INTO ${TABLE_NAME.DOTI_SUGGESTED_QUESTIONS} (question) VALUES (?);`
        for (const q of questions) {
            await db.run({ sql: query, params: [q] })
        }
    } catch (error) {
        console.error('Error saving suggested questions:', error)
    }
}

export const getSuggestedQuestions = async (): Promise<string[]> => {
    try {
        const db = await getDb()
        const result = await db.getAll({ sql: `SELECT question FROM ${TABLE_NAME.DOTI_SUGGESTED_QUESTIONS} ORDER BY _id ASC;` })
        return result.map((row: any) => row.question)
    } catch (error) {
        console.error('Error retrieving suggested questions:', error)
        return []
    }
}